export default "__VITE_ASSET__CCxUWn3w__"